module.exports = __webpack_public_path__ + "static-portal/img/EMS.137bb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EMS.jpg
// module id = 2Tn7
// module chunks = 4